(() => {
  const API_BASE = 'https://api.wyrdstory.com';
  const DEFAULT_CATALOG = {
    currency: 'USD',
    prices: {
      personalizedBook: 70,
      personalizedBookCompareAt: 100,
      extraBookCopy: 49,
      extraBookCopyCompareAt: 70,
      designSetup: 15,
      shipping: 10,
      freeShippingThreshold: 100,
      twentyPortraitUpgrade: 19,
    },
    claims: {
      guaranteeLabel: '30-day money-back guarantee',
      guaranteeBody:
        "If it isn't perfect, we'll redo it or give you a full refund within 30 days — no questions asked.",
    },
  };

  function currencyContext(catalog) {
    const sourceCurrency = String(catalog?.currency || 'USD').toUpperCase();
    const shopifyCurrency = window.Shopify?.currency;
    const pageCurrency = document.querySelector('[data-currency]')?.dataset.currency;
    const activeCurrency = String(shopifyCurrency?.active || pageCurrency || sourceCurrency).toUpperCase();
    const rate = activeCurrency === sourceCurrency ? 1 : Number(shopifyCurrency?.rate);

    // Shopify's rendered prices remain authoritative if a safe conversion rate is unavailable.
    if (!Number.isFinite(rate) || rate <= 0) return null;

    const locale = document.documentElement.lang || window.Shopify?.locale || navigator.language || 'en';
    let formatter;
    try {
      formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency,
        currencyDisplay: 'narrowSymbol',
      });
    } catch (_error) {
      return null;
    }

    return {
      money(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return null;
        return formatter.format(amount * rate);
      },
    };
  }

  function applyCatalog(catalog) {
    const claims = catalog?.claims;
    const prices = catalog?.prices;
    if (!claims || !prices) return;

    const currency = currencyContext(catalog);
    const money = (value) => currency?.money(value) || null;
    const upgradePrice = money(prices.twentyPortraitUpgrade);
    const designSetupPrice = money(prices.designSetup);

    document.querySelectorAll('[data-commerce-price]').forEach((element) => {
      const value = money(prices[element.dataset.commercePrice]);
      if (value) element.textContent = value;
    });
    document.querySelectorAll('[data-commerce-price-sum]').forEach((element) => {
      const keys = String(element.dataset.commercePriceSum || '')
        .split(',')
        .map((key) => key.trim())
        .filter(Boolean);
      const values = keys.map((key) => Number(prices[key]));
      if (values.length && values.every(Number.isFinite)) {
        const value = money(values.reduce((total, item) => total + item, 0));
        if (value) element.textContent = value;
      }
    });
    document.querySelectorAll('[data-commerce-discount-price]').forEach((element) => {
      const price = Number(prices[element.dataset.commerceDiscountPrice]);
      const compareAt = Number(prices[element.dataset.commerceDiscountCompareAt]);
      if (Number.isFinite(price) && Number.isFinite(compareAt) && compareAt > 0) {
        element.textContent = `Save ${Math.max(0, Math.round((1 - price / compareAt) * 100))}%`;
      }
    });
    document.querySelectorAll('[data-commerce-shipping-copy]').forEach((element) => {
      const shipping = money(prices.shipping);
      const threshold = money(prices.freeShippingThreshold);
      if (shipping && threshold) {
        element.textContent = `Shipping is ${shipping} for orders up to ${threshold}. Free shipping over ${threshold}.`;
      }
    });
    document.querySelectorAll('[data-commerce-free-shipping-copy]').forEach((element) => {
      const threshold = money(prices.freeShippingThreshold);
      if (threshold) element.textContent = `Free shipping over ${threshold}`;
    });
    document.querySelectorAll('[data-commerce-guarantee-label]').forEach((element) => {
      element.textContent = claims.guaranteeLabel;
    });
    document.querySelectorAll('[data-commerce-guarantee-body]').forEach((element) => {
      element.textContent = claims.guaranteeBody;
    });

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, template, textarea')) return;
      let value = node.nodeValue || '';
      if (upgradePrice) {
        value = value.replace(/\$19(?=\s+(?:portrait\s+)?upgrade)/gi, upgradePrice);
        value = value.replace(
          /Does the portrait upgrade apply/gi,
          `Does the ${upgradePrice} portrait upgrade apply`
        );
      }
      if (designSetupPrice && /design setup/i.test(value)) {
        value = value.replace(/\$15/g, designSetupPrice);
      }
      value = value.replace(
        /(?:14|30)[ -]day money-back guarantee|30d guarantee|full refund guarantee|100% money-back guarantee/gi,
        claims.guaranteeLabel
      );
      node.nodeValue = value;
    });

    document.querySelectorAll('p, div, span').forEach((element) => {
      const text = (element.textContent || '').trim();
      if (
        /^(?:We offer a |You preview everything before paying.*backed by a |You approve every portrait.*backed by a )/i.test(
          text
        ) && /money-back|refund/i.test(text) && element.children.length === 0
      ) {
        element.textContent = claims.guaranteeBody;
      }
    });

    window.WyrdCommerceCatalog = catalog;
    window.dispatchEvent(new CustomEvent('wyrd:commerce-catalog', { detail: catalog }));
  }

  // Render safe defaults immediately; the API can replace them with the current catalog.
  applyCatalog(DEFAULT_CATALOG);

  fetch(`${API_BASE}/public/commerce-catalog`, {
    headers: { accept: 'application/json' },
    credentials: 'omit',
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((payload) => payload?.catalog && applyCatalog(payload.catalog))
    .catch(() => {});
})();
